import { type CollectionDatum } from 'domains/collections/types/collections.types'

interface MapCollectionsToOptionsArgs {
  defaultLabel: string
  collections: Pick<CollectionDatum, 'id' | 'name'>[]
  editMode: boolean
}

interface CollectionOption {
  label: string
  value: string | undefined
}

export const mapCollectionsToOptions = ({
  defaultLabel,
  collections,
  editMode,
}: MapCollectionsToOptionsArgs): CollectionOption[] => {
  const defaultValue: CollectionOption = {
    label: defaultLabel,
    // The collections domain update endpoint uses '0' to determine if the collection has no parent
    // https://github.com/instacart/carrot/blob/master/customers/customers-backend/domains/collections_domain/app/domain/collections_domain/api/update_collection/api.rb#L41
    // create does not have this logic. If we send '0' for parentId on create, it will set the parentId = 0
    // solution: in editMode send '0' to represent no parent, on create send ''
    value: editMode ? '0' : '',
  }

  const collectionOptions = collections.map(({ id, name }) => ({
    label: name,
    value: id,
  }))

  const allCollectionOptions = [defaultValue, ...collectionOptions]

  return allCollectionOptions
}
